import React from 'react';

import classes from './Input.module.css';

const input = (props) => {
    let inputElement = null;
    let validationError = null;
    const inputClasses = [classes.InputElement];
    if(props.invalid && props.touched){
        inputClasses.push(classes.InValid);
        validationError = <p>Invalid entry</p>
    }

    switch ( props.elementtype){
        case ('input'):
            inputElement = <input 
                className={inputClasses.join(' ')} 
                {...props.elementconfig} 
                value={props.value}
                onChange={props.changed}
                />;
            break;
        case ('textarea'):
            inputElement = <textarea className={inputClasses.join(' ')} {...props.elementconfig} value={props.value}
            onChange={props.changed}/>;
            break;
        default:
            inputElement = <input className={inputClasses.join(' ')} {...props.elementconfig} value={props.value}
            onChange={props.changed}/>;
    }

    return (
        <div className={classes.Input}>
            <label className={classes.Label}>{props.label}</label>
            {inputElement}
            {validationError}
        </div>
    )
}; 

export default input;